const STORAGE_KEY = 'frontdoor_report_favorites';

// TODO(db): Move favorites (including their order) to the same
// `user_report_library_pref` API as reportLibraryOrderStorage. Keep this
// localStorage array as the ordered source of truth until that ships.

export function getStoredFavoriteReportIds(): string[] {
    try {
        const stored = localStorage.getItem(STORAGE_KEY);
        if (!stored) {
            return [];
        }

        const parsed: unknown = JSON.parse(stored);
        if (!Array.isArray(parsed)) {
            return [];
        }

        return parsed.filter((id): id is string => typeof id === 'string');
    } catch {
        return [];
    }
}

export function setStoredFavoriteReportIds(reportIds: string[]): void {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(reportIds));
}
